import types from './actionTypes';

const initialState = {
  loading: false,
  landingPages: [],
  savedLandingId: null,
  savedPublicUrl: null,
  error: '',
};

const landingPage = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_LANDING_PAGE_STATE:
      return initialState;
    case types.SAVE_LANDING_PAGE.REQUEST:
    case types.ARCHIVE_LANDING_PAGE.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.SYNC_LANDING_PAGES.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        landingPages: action.pages,
      };
    case types.SAVE_LANDING_PAGE.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        savedLandingId: action.landingId,
        savedPublicUrl: action.publicUrl,
      };
    case types.ARCHIVE_LANDING_PAGE.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_LANDING_PAGES.FAILURE:
    case types.SAVE_LANDING_PAGE.FAILURE:
    case types.ARCHIVE_LANDING_PAGE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default landingPage;
